import { render, staticRenderFns } from "./selectElement.vue?vue&type=template&id=ed90edce&"
import script from "./selectElement.vue?vue&type=script&lang=js&"
export * from "./selectElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports